<script lang="ts" setup>
const route = useRoute()
const { className } = useTheme()
const locale = useState<string>('locale.setting')
</script>

<template>
  <Html :lang="locale" class="!overflow-visible">
    <Body class="antialiased duration-300 transition-colors !static" :class="className">
      <AppHealthCheck v-if="route?.name === 'locale-status' || route?.name === 'status'" />
      <App v-else />
    </Body>
  </Html>
</template>
